export default __webpack_public_path__ + "static/media/833.005adba6.png";